import { VThemeContext } from './context';

export const useVTheme = VThemeContext.hook;
